import { AlertTriangle, Inbox, RefreshCw } from 'lucide-react'
import type { ReactNode } from 'react'
import { ApiError } from '../../lib/api/client'

export function LoadingBlock({ rows = 4 }: { rows?: number }) {
  return <div className="skeleton-stack" aria-label="Đang tải">{Array.from({ length: rows }, (_, i) => <div className="skeleton" key={i} />)}</div>
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><Inbox aria-hidden="true" /><h3>{title}</h3><p>{description}</p>{action}</div>
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  const apiError = error instanceof ApiError ? error : null
  const title = apiError?.status === 403 ? 'Bạn không có quyền truy cập' : apiError?.kind === 'network' ? 'Không thể kết nối máy chủ' : 'Không tải được dữ liệu'
  return <div className="error-state" role="alert"><AlertTriangle aria-hidden="true" /><div><h3>{title}</h3><p>{apiError?.message ?? 'Đã xảy ra lỗi không xác định.'}</p></div>{retry && <button className="button button--secondary" onClick={retry}><RefreshCw size={16} />Thử lại</button>}</div>
}
